import React, { useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import "bootstrap/dist/css/bootstrap.min.css";

const QRCodeGenerator = () => {
  const [url, setUrl] = useState("https://example.com");
  const [size, setSize] = useState(200);

  const downloadQR = () => {
    const canvas = document.querySelector("canvas");
    const padding = 10; // pixels of padding around QR code

    // Create a new canvas larger than the original
    const newCanvas = document.createElement("canvas");
    const newSize = canvas.width + padding * 2;
    newCanvas.width = newSize;
    newCanvas.height = newSize;

    const ctx = newCanvas.getContext("2d");

    // Fill background (white)
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, newSize, newSize);

    // Draw original QR in center with padding
    ctx.drawImage(canvas, padding, padding);

    // Convert new canvas to PNG for download
    const pngUrl = newCanvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");

    const downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = "qrcode.png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  return (
    <>
      <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
        <h1 class="h2">QR Code Generator</h1>
      </div>
      <div className="mx-auto">
        <h3 className="text-center mb-4"></h3>

        {/* URL Input */}
        <div className="mb-3">
          <label className="form-label fw-bold">Enter URL:</label>
          <input
            type="text"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            className="form-control"
            placeholder="https://example.com"
          />
        </div>

        {/* Size Input */}
        <div className="mb-3">
          <label className="form-label fw-bold">QR Code Size (px):</label>
          <input
            type="number"
            min="100"
            max="600"
            value={size}
            onChange={(e) => setSize(Number(e.target.value))}
            className="form-control"
          />
          <small className="text-muted">
            Adjust size between 100 and 600 pixels
          </small>
        </div>

        {/* QR Code Display */}
        <div className="text-center my-4">
          <div
            className="d-inline-block p-4 bg-light rounded"
            style={{
              border: "1px solid #ddd",
              marginTop: "10px",
            }}
          >
            <QRCodeCanvas value={url} size={size} />
          </div>
          <p className="mt-3 text-muted">Scan this QR code to open the link.</p>
        </div>

        {/* Download Button */}
        <div className="text-center">
          <button className="btn btn-primary px-4" onClick={downloadQR}>
            Download QR Code
          </button>
        </div>
      </div>
    </>
  );
};

export default QRCodeGenerator;
